var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
const StyledTab = styled(Tab) `
    font-size: 12px;
    text-transform: none;
    min-height: 60px;
    padding: 6px 20px;
    color: #e0e0e0;
    &.Mui-selected {
        background: #000;
        color: #8980ef;
    }

    & .MuiSvgIcon-root {
        width: 24px;
        height: 24px;
    }
`;
export const SidebarIconTab = (props) => {
    const tabProps = __rest(props, []);
    return _jsx(StyledTab, Object.assign({}, tabProps));
};
